import apiClient from './apiClient';

// Get Transactions Data
export const getTransactionsApi = async (params) => {
  const response = await apiClient.get('/partners/almata-partners/oem-partners/transactions/list', { params });
  return response.data;
};